export * from "modules/TyresDashboard/components/TyresDashboardTable/hooks/useTyresQuery";
